module.exports = __webpack_public_path__ + "img/delete.9e10febb.svg";